export default "__VITE_ASSET__143aa49b__"